import React from 'react';
import styled from 'styled-components';
import t from 'prop-types';
import {CSSTransition} from 'react-transition-group';

const SideBarRightMainContainer = styled.div`
  width: calc(25% - ${props => props.navBarWidth / 4}px);
  position: fixed;
  top: 0;
  right: 0;
  transform: translateX(110%);
  transition: transform 0.4s;
  height: 100vh;
  &.rightSideBarSlide-enter-active {
    transition-timing-function: ease-out;
    transform: translateX(0%);
  }
  
  &.rightSideBarSlide-enter-done {
    transform: translateX(0%);
  }
  
  &.rightSideBarSlide-exit.rightSideBarSlide-exit-active {
    transform: translateX(110%);
    transition-timing-function: ease-in;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: width 0.4s;
  &.slide-enter-active {
    transition-timing-function: ease-out;
    width: calc(100% - (25% + ${props => props.navBarWidth / 2}px));
  }
  
  &.slide-enter-done {
    width: calc(100% - (25% + ${props => props.navBarWidth / 2}px));
  }
  
  &.slide-exit.slide-exit-active {
    width: 100%;
    transition-timing-function: ease-in;
  }
`;

class WithSlidingRightSideBar extends React.Component {

  render() {
    const {NavBar, children, RightSideBar, navBarWidth = 60, open} = this.props;
    const TemplateNavBar = styled(NavBar)`
      position: fixed;
      top: 0;
      left: 0;
      width: ${navBarWidth}px;
    `;
    return (
      <div style={{display: 'flex', minHeight: '100%'}}>
        <TemplateNavBar />
        <CSSTransition in={open} timeout={400} classNames="slide">
          <ContentContainer style={{marginLeft: navBarWidth}} navBarWidth={navBarWidth}>
            {children}
          </ContentContainer>
        </CSSTransition>
        <CSSTransition in={open} timeout={400} classNames="rightSideBarSlide">
          <SideBarRightMainContainer navBarWidth={navBarWidth}>
            <RightSideBar />
          </SideBarRightMainContainer>
        </CSSTransition>
      </div>
    );
  }
}

WithSlidingRightSideBar.propTypes = {
  NavBar: t.func,
  children: t.array,
  RightSideBar: t.func,
  navBarWidth: t.number,
  open: t.bool
};

export default WithSlidingRightSideBar;
